// extracted by mini-css-extract-plugin
export default {"cardContainer":"MainCard_cardContainer__2tmP4","cardContent":"MainCard_cardContent__BrvYZ","cardContentTwo":"MainCard_cardContentTwo__Yputv"};